var _implements = require('util/interface')._implements;
var BinaryType = require('../../../data/binary/binary');
var BytesImpl = require('data/bytes-impl');

var util = require('data/util');

module.exports = _implements(BinaryType, function BinaryImpl(datatype, buffer, offset, length) {
    BytesImpl.__constructor.call(this, buffer, offset, length);

    var self = this;

    this.get = function() {
        return buffer.slice(self.$offset, self.$offset + self.$length);
    };

    this.diff = function(original, type) {
        type = type || "binary";

        return datatype.deltaType(type).diff(original, self);
    };

    this.apply = function(delta) {
        return datatype.deltaType(delta).apply(self, delta);
    };

    this.toString = function() {
        return "Binary <" + self.$length + " bytes> " + self.get().toString();
    };
});


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/data/binary/binary-impl.js
// module id = 460
// module chunks = 1